import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { CurrencyResponse } from "../../models/dtos";

export const currenciesApi = createApi({
  reducerPath: "currenciesApi",
  baseQuery: baseAuthQuery("Currencies"),
  tagTypes: ["Currency"],
  endpoints: (builder) => ({
    getCurrencies: builder.query<ApiResponse<CurrencyResponse[]>, void>({
      query: () => "",
      providesTags: ["Currency"],
    }),
  }),
});
